export default __webpack_public_path__ + "static/Objective-Thin-097157709f886f4193fbe314d92fcda9.otf";